import React from 'react';

const NoResultsFound = ({ message, minHeight, columSpan = 7 }) => {
    const style = {};
    if (minHeight) style.minHeight = `${minHeight}px`;

    return (
        <tr>
            <td colSpan={columSpan} className="text-center">
                <div className="w-full text-center py-10" style={style}>
                    <p className="text-md text-gray-500">{message}</p>
                </div>
            </td>
        </tr>
    );
};

export default NoResultsFound;
